<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-orders-sidebar ref="handleOrdersSidebar" />

    <vs-prompt
      @cancel="createPromptActive = false"
      @close="createPromptActive = false"
      @accept="createOrder"
      title="Create new order"
      accept-text="Create"
      :active.sync="createPromptActive"
    >
      <div>
        <div>Check below if you want the order to be automatically filled with suggested order lines</div>
        <vs-checkbox v-model="startWithSuggested" label="Start with suggested order lines" class="mt-4" color="primary">
          Start with suggested order lines
        </vs-checkbox>
      </div>
    </vs-prompt>

    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div class="flex justify-end">
        <vs-button icon="add" @click="onClickCreateNew" type="relief" color="primary" class="mr-3">New purchase order</vs-button>
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="10" :data="filteredOrders" @selected="onClicked">
        <template slot="thead">
          <vs-th sort-key="vendorName">Vendor name</vs-th>
          <vs-th sort-key="orderTotalPrice">Total</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th>Created at</vs-th>
          <vs-th>Sent at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start">
                    <img width="40" :src="OrderIcon" />
                    <div class="ml-4">
                      <div>
                        {{ tr.vendorName }}
                      </div>
                      <small class="text-grey">{{ tr.shortId }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                {{ tr.orderTotalPrice }}
                DKK
              </vs-td>
              <vs-td>
                <vs-chip :color="stateMapping[tr.status].color">
                  {{ stateMapping[tr.status].label }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <div class="flex">
                  <feather-icon class="mr-1" icon="CalendarIcon" svgClasses="text-grey w-5 h-5" />
                  {{ tr.createdAction.timestamp | formatDate }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.submittedAction" class="flex">
                  <feather-icon class="mr-1" icon="CalendarIcon" svgClasses="text-grey w-5 h-5" />
                  {{ tr.submittedAction.timestamp | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderIcon from "@/assets/images/order-icon.png";
import moment from "moment";
import HandleOrdersSidebar from "./PurchaseOrderSidebar.vue";

export default {
  components: {
    HandleOrdersSidebar
  },
  props: {
    venueId: {
      type: String,
      default: undefined,
      required: false
    }
  },
  data() {
    return {
      OrderIcon,
      isLoading: true,

      //Create popup
      startWithSuggested: false,
      createPromptActive: false,

      activeVenueId: null
    };
  },
  watch: {
    venueId: {
      handler: async function () {
        this.isLoading = true;
        this.activeVenueId = this.venueId;
        // If no venue id specified, default to active venue
        if (typeof this.venueId == "undefined") {
          this.activeVenueId = this.$store.getters["venues/activeVenueId"];
        }

        await this.$store.dispatch("pos/purchaseOrders/getPurchaseOrdersByVenue", this.activeVenueId);

        this.isLoading = false;
      },
      immediate: true
    }
  },
  methods: {
    onClickCreateNew() {
      this.createPromptActive = true;
    },

    async createOrder() {
      try {
        console.log("creating order");
        var response = await this.$store.dispatch("pos/purchaseOrders/createPurchaseOrder", {
          venueId: this.activeVenueId,
          createWithSuggestedOrderLines: this.startWithSuggested
        });

        this.$refs.handleOrdersSidebar.showOrder(response);

        await this.$store.dispatch("pos/purchaseOrders/getPurchaseOrdersByVenue", this.activeVenueId); // Refresh orders

        this.$vs.notify({
          title: "Purchase order created",
          text: "A new draft order has been created."
        });
        this.startWithSuggested = false;
        this.createPromptActive = false;
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to create order: ${err}`,
          color: "danger"
        });
        console.error(err);
      }
    },
    onClicked(item) {
      this.$refs.handleOrdersSidebar.showOrder(item.id);
    },
    // Check if date is valid using moment
    isValidDate(date) {
      if (!date) return false;
      return moment(date).year() > 1;
    }
  },
  computed: {
    ...mapGetters({
      stateMapping: "pos/purchaseOrders/stateMapping",
      orders: "pos/purchaseOrders/purchaseOrders"
    }),
    filteredOrders() {
      return this.orders.slice().sort((a, b) => (a.createdAction.timestamp < b.createdAction.timestamp ? 1 : -1));
    }
  }
};
</script>